import { Schema } from "effect";
import { MongoCustomerId } from "../ids/mongo-ids";

export const CustomerFacebookAccount = Schema.Struct({
  pageScopedId: Schema.String,
  name: Schema.NullOr(Schema.String),
  link: Schema.NullOr(Schema.String),
});
export type CustomerFacebookAccount = typeof CustomerFacebookAccount.Type;

export const CustomerInstagramAccount = Schema.Struct({
  igScopedUserId: Schema.String,
  username: Schema.NullOr(Schema.String),
  name: Schema.NullOr(Schema.String),
});
export type CustomerInstagramAccount = typeof CustomerInstagramAccount.Type;

/**
 * Basic customer information for display in conversation lists and details.
 * Includes only the essential fields needed for UI rendering.
 */
export const CustomerBasicInfo = Schema.Struct({
  id: MongoCustomerId,
  displayName: Schema.String,
  firstName: Schema.NullOr(Schema.String),
  lastName: Schema.NullOr(Schema.String),
  email: Schema.NullOr(Schema.String),
  phone: Schema.NullOr(Schema.String),
  facebookAccounts: Schema.Array(CustomerFacebookAccount),
  instagramAccounts: Schema.Array(CustomerInstagramAccount),
});

export type CustomerBasicInfo = typeof CustomerBasicInfo.Type;
